import { render, staticRenderFns } from "./summarizing.vue?vue&type=template&id=255754d9&scoped=true&"
import script from "./summarizing.vue?vue&type=script&lang=js&"
export * from "./summarizing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255754d9",
  null
  
)

export default component.exports